module.exports = __webpack_public_path__ + "img/top-logo.10ff4b6.png";